// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"969f74b7","351":"fc9c1f69","958":"0f2c6cee"}[chunkId] + ".chunk.css";
};